<template>
  <div style="cursor: pointer" @click="open">
    <div class="card" style="margin-bottom: 5px;">
      <div class="card-body" style="text-align: center;">
        <div class="row" v-html="parseJson(iconografia)"></div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12"><label class="card-body-label title">{{ title }}</label></div>
        </div>
        <div class="row">
          <div class="col-12"><label class="card-body-label">{{ description }}</label></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "cardFamiliaProducto",
  props: {
    iconografia: "",
    title: "",
    description: "",
    idFamilia: 0
  },
  methods: {
    parseJson(icons){
      if(icons === undefined || icons.length === 0) return "<div class='col-12'>&nbsp</div>";
      let html = "";
      let json = JSON.parse(icons);
      let num = json.length;

      let image = ''

      if(num > 0){
        if (!json[0].includes('http')) {
          image = [process.env.VUE_APP_BACK_URL,json[0]].join('/')
        } else {
          image = json[0]
        }
        html += `<div class='col-12'><img class='icon-img' alt='' src='${image}'></div>`
      }
      else html += "<div class='col-12'>&nbsp</div>"

      return html;
    },
    open(){
      if(this.idFamilia > 0){
        this.$router.push({ name: "Detalle Familia Producto", params: { idFamilia: this.idFamilia }});
      }
    }
  }
}
</script>

<style scoped>
  .card-body-label {
    color: black !important;
  }
  .card-body-label.title {
    font-weight: bold;
  }
</style>
